import React from 'react';

import { ResumeOrBeginButton, ScrollToContinueIndicator } from '../../../Shared/index';
import { ReadAloudContent } from '../../../Shared/components/readAloud/readAloudContent';
import { staticStringSource } from '../../../Shared/libs/speech/clipSource';
import { languageData } from '../../../Shared/libs/translations/modules/languagePageInfo';
import { ENGLISH, rightToLeftLanguages} from '../../../Shared/utils/languageList';

export class LandingPage extends React.Component {

  resume = () => {
    const { resumeActivity, session } = this.props;
    resumeActivity(session);
  }

  renderButton = () => {
    const { begin, session, translate, languageLocale } = this.props;
    const onClickFn = session ? this.resume : begin;
    const text = session ? <span>{translate('buttons^resume')}</span> : <span>{translate('buttons^continue')}</span>;
    return <ResumeOrBeginButton languageLocale={languageLocale} onClickFn={onClickFn} text={text} />
  }

  renderLandingPageText = (language, languageLocale) => {
    const { diagnosticID } = this.props;
    const landingPageInfo = languageData[language].intro[diagnosticID];
    const { header, firstLine, secondLine, thirdLine } = landingPageInfo;
    const textClass = rightToLeftLanguages.includes(language) ? 'right-to-left' : '';
    // right to left languages only have one line, the first
    const isLeftToRight = textClass === '';
    const lang = languageLocale || ''
    return(
      <div className="intro-container" lang={lang}>
        <h1 className={textClass}>{header}</h1>
        <p className={textClass}>{firstLine}</p>
        {isLeftToRight && <p>{secondLine}</p>}
        {isLeftToRight && <p>{thirdLine}</p>}
      </div>
    )
  }

  render() {
    const { diagnosticID, language, languageLocale } = this.props;
    return (
      <div className="landing-page">
        <ReadAloudContent label="Read this page aloud" source={staticStringSource('diagnostic.eslIntro', diagnosticID)}>{this.renderLandingPageText(ENGLISH)}</ReadAloudContent>
        {language !== ENGLISH && this.renderLandingPageText(language, languageLocale)}
        {this.renderButton()}
        <ScrollToContinueIndicator />
      </div>
    );
  }
};

export default LandingPage;
